import CustomerTable from "./CustomerTable";

const Index = ({ setActive }) => {
  return <CustomerTable setActive={setActive} />;
};

export default Index;
